import { RaidPlanCast } from 'app/frontend/types/custom/RaidPlan'

const mapGeneralCastsWithOverlap = (
  casts: RaidPlanCast[],
  cooldown: number,
  color: string,
) => {
  const safeCooldown = Math.max(0, cooldown)
  const sorted = [...casts].sort((a, b) => a.at - b.at)
  let nextAvailableAt = -Infinity
  const issueByCastId = sorted.reduce<
    Record<string, { issueType: 'none' | 'error'; issueMessage?: string }>
  >((acc, cast) => {
    const overlaps = safeCooldown > 0 && cast.at < nextAvailableAt
    acc[cast.id] = overlaps
      ? { issueType: 'error', issueMessage: 'Casts overlap' }
      : { issueType: 'none' }
    nextAvailableAt = cast.at + safeCooldown
    return acc
  }, {})

  return casts.map((cast) => {
    const issue = issueByCastId[cast.id] ?? { issueType: 'none' as const }
    return {
      id: cast.id,
      spellId: cast.spell_id,
      at: cast.at,
      duration: 0,
      cooldown: safeCooldown,
      color,
      issueType: issue.issueType,
      issueMessage: issue.issueMessage,
      note: cast.note,
    }
  })
}

export default mapGeneralCastsWithOverlap
